// Shared with App.tsx (pre-login landing page swap) and login.tsx (branding
// swap) — both need to independently check the CURRENT hostname, since both
// are the same shared components regardless of which domain reached them.
const ROYAL_BRANDS_MARKETING_DOMAINS: string[] = (import.meta.env.VITE_ROYAL_BRANDS_MARKETING_DOMAINS || "")
  .split(",")
  .map((domain: string) => domain.trim().toLowerCase())
  .filter(Boolean);

/**
 * Branding only, never enforcement: whether the given hostname is a
 * configured Royal Brands marketing domain. Access itself is always governed
 * by the logged-in user's isRoyaltyBrand flag, not by domain.
 */
export function isRoyaltyBrandsMarketingHost(hostname: string): boolean {
  return ROYAL_BRANDS_MARKETING_DOMAINS.includes(hostname.toLowerCase());
}
